import React, {useEffect} from 'react';
import {useAuth} from 'react-oidc-context';

/**
 * Clears all cookies accessible to JavaScript on the current origin.
 * IdP session cookies (e.g. idsrv.session) are HttpOnly and must be
 * invalidated by the IdP when signoutRedirect() hits the IdP logout endpoint.
 */
function clearAppCookies(): void {
  const past = 'Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie.split(';').forEach((part) => {
    const name = part.trim().split('=')[0]?.trim();
    if (name) {
      document.cookie = `${name}=;expires=${past};path=/`;
    }
  });
}

function Logout() {
  const auth = useAuth();

  useEffect(() => {
    const performLogout = async () => {
      // Clear app session/local data first (before redirect)
      sessionStorage.removeItem('skip');
      sessionStorage.removeItem('user-account-id');
      sessionStorage.removeItem('selected-tax-year');
      sessionStorage.removeItem('assetType');

      // Clear stored table filters
      Object.keys(localStorage)
        .filter((x) => x.endsWith('_filters'))
        .forEach((x) => localStorage.removeItem(x));

      // Explicitly invalidate any session cookie accessible to JS (disallow reuse)
      clearAppCookies();

      // Clear OIDC user/tokens from storage so session is invalid after redirect
      await auth.removeUser();
    };

    auth.signoutRedirect();

    return () => {
      performLogout();
    };
  }, []);
  return <></>;
}

export default Logout;
